import React, { useEffect } from "react";
import { HashRouter as Router } from "react-router-dom";
import PagesContainer from "./containers/templates/PagesContainer";
import GlobalContainer from "./containers/templates/GlobalContainer";
import webDemoControls from "webdemo-controls";
/*
	About
		- The App handles the routes
		- Add any new logic to pertinent Container
		  - *Logic here will re-render all of the components
		  	- Refer to @loadable/component for more information
		- Keep in mind: only add extra logic that doesn't re-render component
*/
const App: React.FC = () => {
	// TODO(Temporary): Locally, the demo-controls doesn't load fast enough;
	//  Need to refactor (to load before/after all pages load)
	useEffect(() => webDemoControls(), []);

	return (
		<Router>
			<GlobalContainer>
				<PagesContainer />
			</GlobalContainer>
		</Router>
	);
};

export default App;
